import React from "react";

export default function LanguageEN(props: any) {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9.63183 18.5H1.375V5.5H9.61348V8.23202H4.27406V10.7073H9.11807V13.256H4.27406V15.7496H9.63183V18.5Z" fill="currentColor" />
      <path d="M23.375 18.5H20.3108L14.953 9.95557V18.5H12.0723V5.5H15.5952L20.4759 13.4027V5.5H23.375V18.5Z" fill="currentColor" />
    </svg>
  );
}